const IS_IN_TG_STORAGE_NAME = 'isInTelegram';
const TG_WEB_APP_DATA_PARAM = 'tgWebAppData';

export default () => {
	const storedValue = sessionStorage.getItem(IS_IN_TG_STORAGE_NAME);
	const hash = window.location.hash.slice(1);
	const params = new URLSearchParams(hash);

	if (storedValue) {
		return true;
	}

	if (params.has(TG_WEB_APP_DATA_PARAM)) {
		sessionStorage.setItem(IS_IN_TG_STORAGE_NAME, 'true');

		return true;
	}

	return false;
};
